import React from 'react';
import {useSingleTheme} from '../../components/hooks/hooks-mongoDB/useSingleTheme';
import {useArticles} from '../../components/hooks/hooks-mongoDB/useArticles';
import {useParagraphs} from '../../components/hooks/hooks-mongoDB/useParagraphs';
import ThemesScreen from '../../components/modules/pannelli/ThemesScreen';
import {NavHeadLinks} from '../../components/modules/pannelli/HeadLink';
import EventiVinXS from '../../components/images/abruzzowines/intestato/EventiViniABW500.png';
import EventiVinS from '../../components/images/abruzzowines/intestato/EventiViniABW800.png';
import EventiVinM from '../../components/images/abruzzowines/intestato/EventiViniABW1200.png';
import EventiVinL from '../../components/images/abruzzowines/intestato/EventiViniABW1600.png';
import EventiVinXL from '../../components/images/abruzzowines/intestato/EventiViniABW2000.png';
import EventiVinXXL from '../../components/images/abruzzowines/intestato/EventiViniABW3500.png';
import '../../components/modules/pannelli/themesScreen.scss';

function EventoEnogastro() {
    const {theme} = useSingleTheme('eventi');
    const eventi_Theme = theme;
    const {articles} = useArticles('abruzzowines');
    const article = articles.slice(3, 4) || [];
    const articles_Eventi = article[0];
    const {paragraphs} = useParagraphs('abruzzowines_4');

    return (
        <section>
            {theme && <NavHeadLinks title={eventi_Theme.tema_titolo} picXS={EventiVinXS}  picS={EventiVinS}  picM={EventiVinM} picL={EventiVinL} picXL={EventiVinXL} picXXL={EventiVinXXL} />}
            <ThemesScreen theme={eventi_Theme} article={articles_Eventi} paragraphs={paragraphs}/> 
        </section>
    )
}
export default EventoEnogastro;
